import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProductSearch, useWishlist } from '../hooks/useProducts';
import ProductGrid from '../components/product/ProductGrid';
import { useAuthStore } from '../stores/authStore';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const { t } = useTranslation();
  const { isAuthenticated } = useAuthStore();

  const { data, isLoading } = useProductSearch(query);
  const { data: wishlist } = useWishlist();

  const wishlistIds = wishlist?.map((item) => item.id) || [];
  const products = data?.products || [];

  return (
    <div className="container mx-auto px-4 py-6">
      {/* Breadcrumb */}
      <nav className="text-sm text-gray-500 mb-4">
        <Link to="/" className="hover:text-primary">{t('nav.home')}</Link>
        <span className="mx-2">/</span>
        <span className="text-gray-900">{t('common.search')}</span>
      </nav>

      {/* Search Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold">
          {t('common.search')}: "{query}"
        </h1>
        {data?.pagination && (
          <p className="text-gray-500 mt-1">
            {data.pagination.total} {t('common.noResults').replace('לא נמצאו תוצאות', 'results').replace('No results found', 'results')}
          </p>
        )}
      </div>

      {/* Results */}
      {query.length < 2 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg">
          <svg
            className="w-16 h-16 mx-auto text-gray-300 mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <p className="text-gray-500">{t('common.searchPlaceholder')}</p>
        </div>
      ) : (
        <ProductGrid
          products={products}
          wishlistIds={isAuthenticated ? wishlistIds : []}
          isLoading={isLoading}
          emptyMessage={t('common.noResults')}
        />
      )}
    </div>
  );
}
